<template>
    <div v-if="loaded" class="container bng-promotions bng-narrow-container">
        <img src="/static/promotions/deposit-100-min.jpg" alt="Welcome bonus">
        <h1>Bonus Rules</h1>
        <p><strong>Daily Bonus</strong></p>
        <p>The bonus for the first deposit of the day is calculated daily as 200% of the deposit amount.</p>
        <p>Each bonus is provided under certain conditions and with certain limitations that the User should comply with in order to be able to withdraw bonus funds from the account. Depending on the type of the bonus offered, you may be required to fulfil certain conditions in order to be able to withdraw from the account the funds obtained as a result of a successful betting involving the bonus.</p>
        <p><strong>Bonus accrual</strong></p>
        <ul>
            <li>Top-up your balance.</li>
            <li>The bonus is automatically accrued after the player replenishes the balance, provided that they currently have no other active bonuses.</li>
        </ul>
        <p><strong>Terms and conditions</strong></p>
        <ul>
            <li>The User is eligible only for 1 bonus per day.</li>
            <li>The bonus is automatically accrued after the first deposit to the account, provided that the player has no other active bonuses at the moment.</li>
            <li>The withdrawal of bonus funds is not possible until the turnover terms are fulfilled.</li>
            <li>Turnover terms
                <ul>
                    <li>
                        Casino: 2.5% from each bet below ₸1,000.00 for KZT, ₽1,000.00 for RUB, 50.00 Bs. for VEF, ₲1,000.00 for PYG, 100,000.00 USh for UGX, 1,000.00 £S for SYP,
                    </li>
                    <li>
                        Live Games: 2% from each bet below ₸5,000.00 for KZT, ₽5,000.00 for RUB, 50.00 Bs. for VEF, ₲1,000.00 for PYG, 100,000.00 USh for UGX, 1,000.00 £S for SYP,
                    </li>
                    <li>
                        Sport: 1% from each bet below ₸5,000.00 for KZT, ₽5,000.00 for RUB, 50.00 Bs. for VEF, ₲1,000.00 for PYG, 100,000.00 USh for UGX, 1,000.00 £S for SYP, with the rate >= 1.4
                    </li>
                    <li>
                        Virtual Sports: 2% from each bet below ₸5,000.00 for KZT, ₽5,000.00 for RUB, 50.00 Bs. for VEF, ₲1,000.00 for PYG, 100,000.00 USh for UGX, 1,000.00 £S for SYP, with the rate >= 1.4
                    </li>
                </ul>
            </li>
            <li>The offer cannot be applied in combination with other promotions or special offers.</li>
            <li>We grant only one bonus per user, family, address, shared computer, common IP-address and any identical account data, such as e-mail, bank account, credit card details or payment system account. In case of any violation of the rules of the bonus program, the account shall be disabled.</li>
            <li>The turnover bonus is transferred to the main account in the amount of the bonus funds on the balance, but not more than 1000% from initial bonus value.</li>
            <li>If any funds are withdrawn, the bonus shall be cancelled.</li>
            <li>The rules of the promotion are subject to change.</li>
        </ul>
        <p><strong>Bonus coupon</strong></p>
        <p>This bonus is credited immediately upon activation of the coupon, provided that the player does not currently have another active bonus. If activation failed (for example, if there is an active bonus), then the coupon can be reused later.</p>
        <p>Each bonus is provided under certain conditions and with certain limitations that the User should comply with in order to be able to withdraw bonus funds from the account. Depending on the type of the bonus offered, you may be required to fulfil certain conditions in order to be able to withdraw from the account the funds obtained as a result of a successful betting involving the bonus.</p>
        <ul>
            <li>The withdrawal of funds is not possible until the turnover terms are fulfilled.</li>
            <li>Turnover terms
                <ul>
                    <li>
                        Casino: 2.5% from each bet below ₸1,000.00 for KZT, ₽1,000.00 for RUB, 50.00 Bs. for VEF, ₲1,000.00 for PYG, 100,000.00 USh for UGX, 1,000.00 £S for SYP,
                    </li>
                    <li>
                        Live Games: 2% from each bet below ₸5,000.00 for KZT, ₽5,000.00 for RUB, 50.00 Bs. for VEF, ₲1,000.00 for PYG, 100,000.00 USh for UGX, 1,000.00 £S for SYP,
                    </li>
                    <li>
                        Sport: 1% from each bet below ₸5,000.00 for KZT, ₽5,000.00 for RUB, 50.00 Bs. for VEF, ₲1,000.00 for PYG, 100,000.00 USh for UGX, 1,000.00 £S for SYP, with the rate >= 1.4
                    </li>
                    <li>
                        Virtual Sports: 2% from each bet below ₸5,000.00 for KZT, ₽5,000.00 for RUB, 50.00 Bs. for VEF, ₲1,000.00 for PYG, 100,000.00 USh for UGX, 1,000.00 £S for SYP, with the rate >= 1.4
                    </li>
                </ul>
            </li>
            <li>The offer cannot be applied in combination with other promotions or special offers.</li>
            <li>We grant only one bonus per user, family, address, shared computer, common IP-address and any identical account data, such as e-mail, bank account, credit card details or payment system account. In case of any violation of the rules of the bonus program, the account shall be disabled.</li>
            <li>The turnover bonus is transferred to the main account in the amount of the bonus funds on the balance, but not more than 1000% from initial bonus value.</li>
            <li>If any funds are withdrawn, the bonus shall be cancelled.</li>
            <li>The rules of the promotion are subject to change.</li>
        </ul>
        <p><strong>Cashback</strong></p>
        <p>CASHBACK is a bonus program offering a refund after a negative series.</p>
        <p><strong>Terms and conditions</strong></p>
        <ul>
            <li>The Cashback Bonus is accrued to the account every 7 days.</li>
            <li>It amounts to 10% of the amount lost in the previous 7 days.</li>
            <li>Next bonus accrual: 11/18 15:00.</li>
            <li>When calculating the bonus, only bets made in the "Casino" section of the site are taken into account.</li>
            <li>The rules of the promotion are subject to change.</li>
        </ul>
        <a
            @click="goToBonusRules()"
            class="banners-cell__button banners-cell__button--access"
        >ACCESS</a>
    </div>
</template>
<script>
import Vue from 'vue';
export default {
    name: 'promotions-welcome-bonus',
    data() {
        return {
            loaded: false,
        };
    },
    async created() {
        this.loaded = true;
    },
    methods: {
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        }
    }
}
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/promotions/promotions-welcome-bonus.vue